import React from 'react'

import * as S from './styles'
import { DarkNhShape } from '@/assets/imgs'

type NatomProps = {
  /**
   * Styles to be applied to the container of the atom
   *
   * @example
   * ```tsx
   * <Natom containerStyles={{ width: '100px' }} />
   * ```
   */
  containerStyles?: React.CSSProperties
}

export const Natom: React.FC<NatomProps> = ({ containerStyles }) => (
  <S.Atom style={containerStyles}>
    <S.Nucleus
      src={DarkNhShape}
      alt="Logo escura nata.house"
      width={0}
      height={0}
    />

    <S.Orbit>
      <S.PrimaryElectron animationTime={6} />

      <S.SecondaryElectron animationTime={6} />
    </S.Orbit>

    <S.Orbit>
      <S.PrimaryElectron animationTime={4.5} />

      <S.SecondaryElectron animationTime={4.5} />
    </S.Orbit>

    <S.Orbit>
      <S.PrimaryElectron animationTime={3} />

      <S.SecondaryElectron animationTime={3} />
    </S.Orbit>
  </S.Atom>
)
